// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignLimitsResult = objectOf({
  iam_active_count: number,
  iam_active_limit: number,
  iam_notify_threshold: boolean,
  content_card_active_count: number,
  content_card_active_limit: number,
  content_card_notify_threshold: boolean,
  ff_exp_active_count: number,
  ff_exp_active_limit: number,
});
